var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWindrad(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: 90,
    height: 93.045,
    viewBox: "0 0 200 200",
    style: {
      enableBackground: "new 0 0 200 200"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#00488E",
    className: "st0",
    d: "M180,82.5c0-19.1-13.4-32.5-32.5-32.5S115,63.4,115,82.5h10c0-13.7,8.8-22.5,22.5-22.5S170,68.8,170,82.5 s-8.8,22.5-22.5,22.5H20v10h90c15.2,0,25,9.8,25,25s-9.8,25-25,25c-15.2,0-25-9.8-25-25H75c0,20.6,14.4,35,35,35s35-14.4,35-35 c0-10.2-3.5-18.8-9.6-25H150v-0.1C167.8,113.8,180,100.8,180,82.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00488E",
    className: "st0",
    d: "M110,55c0-17.7-12.3-30-30-30S50,37.3,50,55h10c0-12.1,7.9-20,20-20s20,7.9,20,20s-7.9,20-20,20H20v10h60 C97.7,85,110,72.7,110,55z"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#00488E",
    x: 20,
    y: 135,
    className: "st0",
    width: 35,
    height: 10
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWindrad);
export default __webpack_public_path__ + "static/media/windrad.f67fa1d4c27809437e0422c9e4d39ed4.svg";
export { ForwardRef as ReactComponent };